const UserAccessButtonComponent = {
    templateUrl: '/ui/user/dropdown/userAccess/userAccessButton.tpl.html',
    controller: 'userAccessButtonController',
    bindings: {}
};

angular.module('umCore')
    .component('userAccessButton', UserAccessButtonComponent);
